<template>
    <div class="qsc-project">
        <div class="container">
                <div class="project-title">{{proDetail.title}}</div>

                <div class="col-md-8">
                    <div  v-bind:class="navBarFixed == true ? 'navFixed' :'project-nav'">
                        <ul>
                            <li class="menuItem" :class="{ active:shows==1 }" @click="one"><a href="#" v-scroll-to="'#proDetail'">项目故事</a></li>
                            <li class="menuItem" v-if="showTimeline" :class="{ active:shows==2 }" @click="two"><a href="#" v-scroll-to="'#proTimeline'">进展追溯</a></li>
                            <li class="menuItem" :class="{ active:shows==3 }" @click="three"><a href="#" v-scroll-to="'#proSupport'">捐款互动</a></li>
                        </ul>
                    </div>

                    <!-- start [项目详情] -->
                    <div class="qsc-project-detail" id="proDetail">
                        <div v-html="proDetail.detail" class="project-content"></div>
                    </div>
                    <!-- start [项目详情] -->

                    <!-- start [进展追溯] -->
                    <div class="project-detail-box" id="proTimeline" v-if="showTimeline">
                        <div class="project-detail_title">进展追溯</div>
                        <div class="project-timeline">
                            <div class="timeline-item" v-for="item in proTimeline" :key="item.id">
                                <div class="timeline-item_content">
                                    <h6 class="timeline-item_content_user"><small>{{item.topics_state}}</small></h6>
                                    <p class="timeline-item_content_time">{{item.created | formatDate}}
                                        <a class="timeline-item_content_comment" href="javascript:void(0)" data-toggle="modal" data-target="#modal-comment-reply"><i class="icon-comment"></i></a>
                                    </p>
                                    <p class="timeline-item_content_talk">{{item.content}}</p>
                                    <div class="mod-project-card_content__img">
                                        <div class="fancybox" v-for="array in item.image" :key="array.id">
                                            <img class="lazy-load" :src="array.thumb" :data-original="array.thumb" width="100%" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end [进展追溯] -->

                    <!-- start [TA的支持者] -->
                    <div class="project-detail-box mod-project-supporter" id="proSupport">
                        <div class="project-detail_title">
                            <div class="head-left-sign"></div>
                            <div class="head-content"><span>{{proSupport.count}} </span>位爱心人士参与捐款</div>
                        </div>

                        <div class="mod-project-support_item" v-for="item in tempList" :key="item.id">
                            <div class="mod-project-support_item__user">
                                <img class="lazy-load" :src="item.user.avatar_thumb" :data-original="item.user.avatar_thumb" width="100%" :alt="item.user.nickname" />
                            </div>
                            <div class="mod-project-support_item__detail">
                                <div class="project-support_item__detail__user">{{item.user.nickname}}<small> 支持了 <strong>{{item.money}}</strong> 元</small></div>
                                <div class="project-support_item__detail__time">{{item.pay_at | formatDate}}
                                    <a class="project-support_item__detail_comment" href="javascript:void(0)" data-toggle="modal" data-target="#modal-comment-reply"><i class="icon-comment"></i></a>
                                </div>
                                <div class="project-support_item__detail__content">{{item.content}}</div>
                            </div>
                        </div>
                        <div class="load_more" v-show="!isLoading && hasMore" @click="loadMore">
                            查看更多
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAOCAMAAADt5EdyAAAAQlBMVEUAAACdnZ2ampqampqbm5udnZ2ampqampqjo6OZmZmampqbm5uZmZmioqKampqbm5ubm5uampqampqZmZmampqZmZmzMKmEAAAAFXRSTlMAF/DGNQ/UegzZzS7sEe6EgGWGZFhd9f4LAAAAWUlEQVQY02XMSw6AIBAE0UZFUT6KOve/qkPIGJKu7UsKCACXq8crG4NbpSJOSgyHBxYlhgwYERjR6qdrgFmBye0GRklOhk5FiaEVi9wNAkCUZDJg6sC5Z4QPFREEODCndYgAAAAASUVORK5CYII=">
                        </div>
                        <div v-if="!hasMore" class="no_more">只有这么多了~</div>
                    </div>
                    <!-- end [TA的支持者] -->

                </div>

                <div class="col-md-4">
                    <div class="project-sidebar">
                        <!-- start [项目状态] -->
                        <div class="qsc-project-status">
                            <div class="qsc-project-status_detail">
                                <div class="item">
                                    <strong>{{proDetail.total_amount}}<small>元</small></strong>
                                    <span>目标金额</span>
                                </div>
                                <div class="item">
                                    <strong>{{proDetail.current_amount}}<small>元</small></strong>
                                    <span>已筹金额</span>
                                </div>
                                <div class="item">
                                    <strong>{{proDetail.backer_count}}<small>人</small></strong>
                                    <span>捐款人数</span>
                                </div>
                                <div class="item">
                                    <strong>{{proDetail.share_count}}<small>次</small></strong>
                                    <span>转发次数</span>
                                </div>
                            </div>
                            <div class="project-qrcode">
                                <div class="project-qrcode_code">
                                    <qriously :value="initQCode" :size="140"/>
                                </div>
                                <div class="project-qrcode_tips">
                                    扫描二维码<br><span class="text-success">支持TA</span>
                                </div>
                            </div>
                        </div>
                        <!-- end [项目状态] -->

                        <!-- start [项目发起人] -->
                        <div class="qsc-project-sponsor">
                            <p>发起机构</p>
                            <div class="content">
                                <img :src="nodePb.publish_organization.avatar" width="40" height="40">
                                <div class="sponsor-content">
                                    <strong>机构名称：{{nodePb.publish_organization.name}}</strong>
                                    <span>统一社会信用代码：<br>{{nodePb.publish_organization.social_credit_no}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="qsc-project-sponsor" v-if='showSponsor'>
                            <p>执行机构</p>
                            <div class="content">
                                <img :src="nodePb.execution_organization.avatar" width="40" height="40">
                                <div class="sponsor-content">
                                    <strong>机构名称：{{nodePb.execution_organization.name}}</strong>
                                    <span>邮箱：{{nodePb.execution_organization.email}}</span>
                                    <span>电话：{{nodePb.execution_organization.phone}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="qsc-project-sponsor" v-if='showSponsor'>
                            <p>发起人信息</p>
                            <div class="content">
                                <img :src="nodePb.publisher.avatar" width="40" height="40">
                                <div class="sponsor-content">
                                    <strong>发起人：{{nodePb.publisher.name}}</strong>
                                    <span>邮箱：{{nodePb.publisher.email}}</span>
                                    <span>电话：{{nodePb.publisher.phone}}</span>
                                </div>
                                <div class="intro">介绍：{{nodePb.publisher.intro}}</div>
                            </div>
                        </div>
                        <div class="qsc-project-sponsor">
                            <p>善款接收方</p>
                            <div class="content">
                                <img :src="nodePb.receive_fund.avatar" width="40" height="40">
                                <div class="sponsor-content">
                                    <strong>机构名称：{{nodePb.receive_fund.name}}</strong>
                                    <span>收款银行：{{nodePb.receive_fund.bank_location}}</span>
                                    <span>银行卡号：{{nodePb.receive_fund.bank_card_no}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- end [项目发起人] -->
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VueQriously from 'vue-qriously'

Vue.use(VueQriously)
Vue.use(VueScrollTo)
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })
export default {
    mounted () {
        // 事件监听滚动条
        window.addEventListener('scroll', this.watchScroll)
    },
    data() {
        return {
            initQCode: '',

            navBarFixed:false,
            shows: 1,

            showSponsor: false,

            channelId:'',
            projectId:'',
            orderNextId:'0',
            shareNextId: 0,

            proDetail: [],
            proSupport: [],
            proTimeline: [],
            showTimeline: false,
            tempList: [],
            nodePb:{
                publish_organization:{
                    avatar:{}
                },
                execution_organization:{
                    avatar:{}
                },
                publisher:{
                    avatar:{}
                },
                receive_fund: {
                    avatar:{}
                }
            }

        }
    },
    props: {
        hasMore: {
            type: Boolean,
            default: true
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatDate: function (value) {
            let date = new Date(value*1000);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    },
    methods: {
        watchScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop
            if (scrollTop > 300) {
                this.navBarFixed = true
            } else {
                this.navBarFixed = false
            }
        },
        getDetail() {
            this.channelId = this.$route.query.ChannelId
            this.projectId = this.$route.query.id
            this.initQCode = 'https://yglian.qschou.com/gongyi/publicSite/detail?ChannelId=' + this.channelId + '&id=' + this.projectId
            axios.get('https://partner-gateway.qschou.com/' + this.channelId + '/project/' + this.projectId + '/info').then((res) => {
                res = res.data;
                if (res.code === 0) {
                    this.proDetail = res.data
                }
            }).catch(error => {
                if (error.status === 401) {
                    document.querySelector('.mask-authority').style.display = 'block';
                }
            });
        },
        getDetailSupporter() {
            axios.get('https://partner-gateway.qschou.com/' + this.channelId + '/project/' + this.projectId + '/backer?order_next_id=' + this.orderNextId + '&share_next_id=' + this.shareNextId).then((res) => {
                res = res.data;
                if (res.code === 0) {
                    this.proSupport = res.data
                    this.tempList = this.tempList.concat(res.data.list)
                    this.orderNextId = res.data.order_next_id
                    this.shareNextId = res.data.share_next_id
                }
            }).catch(error => {
                if (error.status === 401) {
                    document.querySelector('.mask-authority').style.display = 'block';
                }
            });
        },
        getDetailFeed() {
            axios.get('https://partner-gateway.qschou.com/' + this.channelId + '/project/' + this.projectId + '/feed').then((res) => {
                res = res.data;
                if (res.data.topics.length !== 0) {
                    this.showTimeline = true;
                    for(let i = 0;i < res.data.topics.length; i++){
                        if(res.data.topics[i].topics_state == 2){
                            res.data.topics[i].topics_state='项目更新';
                        }else{
                            res.data.topics[i].topics_state='项目发起';
                            res.data.topics[i].content='项目筹集目标' + res.data.topics[i].content + '元';
                        }
                        this.proTimeline = res.data.topics;
                    }   
                }
            }).catch(error => {
                if (error.status === 401) {
                    document.querySelector('.mask-authority').style.display = 'block';
                }
            });
        },
        getDetailExtra() {
            axios.get('https://partner-gateway.qschou.com/' + this.channelId + '/project/' + this.projectId + '/extra').then((res) => {
                res = res.data;
                if (res.code === 0) {
                    this.nodePb = res.data
                    if (res.data.execution_organization.name !== '') {
                        this.showSponsor = true 
                    }
                }
            }).catch(error => {
                if (error.status === 401) {
                    document.querySelector('.mask-authority').style.display = 'block';
                }
            });
        },
        loadMore () {
            let self = this
            self.getDetailSupporter()
        },
        one() {
            this.shows = 1;
        },
        two() {
            this.shows = 2;
        },
        three() {
            this.shows = 3;
        },
    },
    created () {
        this.getDetail()
        this.getDetailSupporter()
        this.getDetailFeed()
        this.getDetailExtra()
    }
}
</script>

<style lang="less" scoped>

a {
  text-decoration:none;
}
.qsc-project{
    background: #F7F9FA;
    .container {
        display: inline-block;
        width: 1170px;
        margin-right: auto;
        margin-left: auto;
        padding-right: 15px;
        padding-left: 15px;
        // 项目标题
        .project-title {
            text-align: left;
            font-size: 30px;
            font-weight: 600;
            padding: 50px 0;
        }
        .col-md-8 {
            float: left;
            width: 66%;
            text-align: left;
            // 项目导航
            .navFixed {
                position:fixed;
                top:0;
                z-index:1000;
                width: 770px;
            }
            .project-nav,.navFixed{
                background: #fff;
                height: 54px;
                border: 1px solid #E1E5E7;
                z-index: 1000;
                ul{
                    list-style: none;
                    margin: 0;
                    padding: 0;

                }
                li{
                    display: inline-block;
                    a{
                        display: block;
                        padding: 16px 0;
                        width: 140px;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 600;
                        color: #6F7A7E;
                        border-right: 1px solid #E1E5E7;
                    }
                    &.active{
                        a{
                            color: #d13c3c;
                            font-weight: 600;
                        }
                    }
                }
            }
            // 项目详情内容
            .qsc-project-detail{
                background: #fff;
                border: 1px solid #E1E5E7;
                border-radius: 2px;
                margin-bottom: 20px;
                padding: 15px;
                position: relative;
                top: -1px;
            }
            // 项目详情页
            .project-detail-box{
                background: #fff;
                border: 1px solid #E1E5E7;
                border-radius: 2px;
                margin-bottom: 20px;
                .time:before{
                    position: absolute;
                    top: 28px;
                    left: 72px;
                    z-index: 1;
                    width: 2px;
                    height: 10px!important;
                    display: block;
                    background: transparent!important;
                    content: " ";
                }
                .project-detail_title{
                    border-top: none;
                    color: #2B3845;
                    padding: 15px 15px 10px;
                    font-size: 18px;
                    position: relative;

                    small{
                        color: #6F7A7E;
                    }
                    i{
                        font-style: normal;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                    strong{
                        color: #f25b4b;
                        font-weight: 400;
                        margin: 0 5px;
                    }
                    .btn{
                        padding: 6px 15px;
                        font-size: 15px;
                        &.btn-default{
                        color: #d13c3c;
                        }
                    }
                }
                // 项目动态
                .project-timeline {
                    margin-left: 25px;
                    border-left: 2px solid #f2f2f2;
                    .timeline-item {
                        position: relative;
                        margin-bottom: 20px;
                        padding-left: 20px;
                        padding-right: 20px;
                        .time{
                            position: absolute;
                            top: 0;
                            left: -100px;
                            width: 60px;
                            .timeline-item_user{
                                position: absolute;
                                right: -49px;
                                top: -5px;
                                width: 50px;
                                height: 50px;
                                border: 2px solid #fff;
                                img{
                                border-radius: 9999px;
                                }
                                .icon-progress{
                                width: 18px;
                                height: 18px;
                                display: block;
                                position: absolute;
                                bottom: -3px;
                                right: -3px;
                                border-radius: 9999px;
                                }
                            }
                        }

                        .timeline-item_content{
                            border-bottom: 1px solid #E6E8E8;
                            .timeline-item_content_user{
                                margin: 5px 0;
                                font-size: 15px;
                                color: #2B3845;
                                font-weight: 400;
                                small{
                                    font-weight: 400;
                                    color: #d13c3c;
                                    font-size: 14px;
                                }
                            }
                            .timeline-item_content_time{
                                margin: 0;
                                font-size: 12px;
                                color: #999;
                                position: relative;
                                .timeline-item_content_comment{
                                position: absolute;
                                top: -12px;
                                right: 0;
                                font-size: 14px;
                                padding: 10px 10px 10px 15px;
                                &:active{
                                    background: none !important;
                                }
                                }
                            }
                            .timeline-item_content_talk{
                                font-weight: 400;
                                margin: 20px 20px 20px 0;
                                font-size: 15px;
                                color: #222;
                                line-height: 1.5;
                                word-break: break-all;
                                word-wrap: break-word;
                                strong{
                                color: #4284B6;
                                font-weight: 400;
                                }
                            }
                            .timeline-item_content_talk__comment{
                                position: relative;
                                z-index: 1;
                                margin-bottom: 10px;
                                background: #F7F9FA;
                                padding: 5px 0;
                                a{
                                padding: 5px 10px;
                                color: #2B3845;
                                line-height: 1.3;
                                display: block;
                                cursor: default;
                                word-break:break-all;
                                word-wrap:break-word;
                                strong{
                                    color: #4284B6;
                                    font-weight: 400;
                                }
                                }
                                .comment_switch{
                                padding: 8px 0;
                                text-align: center;
                                color: #4284b6!important;
                                font-weight: 400!important;
                                }
                            }
                            .mod-project-card_content__img{
                                padding-bottom: 20px;
                                display: inline-block;
                                .fancybox {
                                    width: 120px;
                                    height: 120px;
                                    display: inline-flex;
                                    margin-right: 10px;
                                    margin-bottom: 10px;
                                }
                            }

                            .mod-project-card_content__list .qsc-list-group{
                                .list-thumb-md{
                                padding: 10px 10px 8px 40px;
                                }
                                .list-thumb strong > .icon{
                                left: 0;
                                }
                            }
                        }

                        &:last-child{
                            .timeline-item_content{
                                border-bottom: none;
                            }
                        }
                    }
                }
                //加载更多
                .load_more {
                    border-radius: 6px;
                    color: #7b7b7b;
                    font-size: 15px;
                    line-height: 14px;
                    background-color: #f8f8f8;
                    width: 120px;
                    text-align: center;
                    margin: 5px auto 20px;
                    padding: 15px 10px;
                    img {
                        width: 15px;
                        height: 10px;
                        margin-left: 2px;
                    }
                }
            }
            // 项目支持者
            .mod-project-supporter{
                .project-detail_title {
                        border-top: none;
                        color: #2B3845;
                        padding: 15px;
                        font-size: 18px;
                        position: relative;
                        border-bottom: 1px solid #E1E5E7;
                            margin-bottom: 15px;
                    .head-left-sign {
                        display: inline-block;
                        width: 5px;
                        height: 22px;
                        background-color: #ed2424;
                        margin-right: 30px;
                        margin-left: 5px;
                        margin-top: -4px;
                        vertical-align: middle;
                    }
                    .head-content {
                        display: inline-block;
                        span{
                            color: #ed2424;
                            font-weight: bold;
                        }
                    }
                }
                .mod-project-support_item{
                    padding: 15px 25px;
                    border-bottom: none;
                    &:last-child{
                    border-bottom: none;
                    }
                }

                .mod-project-support_item__user{
                    float: left;
                    width: 50px;
                    height: 50px;
                    overflow: hidden;
                    display: block;
                    img{
                    border-radius: 999px;
                    width: 40px;
                    height: 40px;
                    }
                }

                .mod-project-support_item__detail{
                    padding: 0 0 20px;
                    border-bottom: 1px solid #E1E5E7;
                    margin-left: 60px;
                    margin-right: 15px;
                    .project-support_item__detail__user {
                        position: relative;
                        margin-top: 0;
                        margin-bottom: 5px;
                        font-size: 15px;
                        line-height: 1;
                        small {
                            position: absolute;
                            font-size: 14px;
                            color: #2B3845;
                            right: 0;
                            strong {
                                color: #f25b4b;
                                font-weight: bold;
                                margin-left: 5px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .project-support_item__detail__time{
                        font-size: 12px;
                        color: #999;
                        position: relative;
                        .project-support_item__detail_comment{
                            position: absolute;
                            top: -12px;
                            right: -10px;
                            font-size: 13px;
                            padding: 10px 10px 10px 15px;
                            &:active{
                                background: none !important;
                            }
                        }
                    }
                    .project-support_item__detail__content{
                        font-size: 15px;
                        margin: 10px 0;
                        color: #222;
                    }

                    .mod-project-card_content__img{
                        padding: 0 15px 10px 0 !important;
                        &.update-img{
                            padding: 0 !important;
                            img{
                            width: 30%;
                            max-width: 100px;
                            margin-bottom: 8px;
                            margin-right: 4px;
                            }
                        }
                    }
                    .mod-project-support_item__detail__comment{
                        position: relative;
                        z-index: 1;
                        background: #F7F9FA;
                        padding: 5px 0;
                        a{
                            padding: 5px 10px;
                            color: #2B3845;
                            line-height: 1.3;
                            display: block;
                            cursor: default;
                            strong{
                            color: #4284B6;
                            font-weight: 400;
                            }
                        }
                        .comment_switch{
                            padding: 8px 0;
                            text-align: center;
                            color: #4284b6!important;
                            font-weight: 400!important;
                        }
                        .icon-triangle{
                            position: absolute;
                            top: -6px;
                            left: 6px;
                            width: 0;
                            height: 0;
                            border-left: 6px solid transparent;
                            border-right: 6px solid transparent;
                            border-bottom: 6px solid #f5f5f5;
                        }
                    }
                }

            }
        }
        .col-md-4 {
            position: relative;
            text-align: left;
            width: 31%;
            float: right;
            // 项目详情侧栏
            .project-sidebar{
                // 项目状态
                .qsc-project-status{
                    background: #FAFBFC;
                    border: 1px solid #E1E5E7;
                    margin-bottom: 20px;
                    padding-top: 20px;
                    .qsc-project-status_detail{
                        display: inline-block;
                        width: 100%;
                        .item{
                            width: 50%;
                            text-align: center;
                            color: #999;
                            margin-bottom: 25px;
                            display: inherit;
                            span{
                                font-size: 15px;
                                background: #FAFBFC;
                            }
                            strong{
                                color: #d13c3c;
                                font-size: 23px;
                                display: block;
                                small{
                                    font-size: 15px;
                                    margin-left: 3px;
                                    font-weight: normal;
                                }
                            }
                        }
                    }
                    .project-qrcode {
                        display: flex;
                        justify-content: space-around;
                        border-top: 1px solid #EDEFF1;
                        padding: 15px;
                        background-color: #fff;
                        .project-qrcode_code {
                            width: 140px;
                            height: 140px;
                            margin-left: -20px;
                        }
                        .project-qrcode_tips {
                            font-size: 18px;
                            font-weight: 600;
                            margin-top: 40px;
                            span {
                                font-size: 24px;
                                color: #d13c3c;
                            }
                        }
                    }
                }
                // 项目发起人
                .qsc-project-sponsor{
                    padding: 15px;
                    background: #fff;
                    border: 1px solid #E1E5E7;
                    margin-bottom: 10px;
                    .content {
                        display: inline-block;
                        img{
                            border-radius: 50%;
                            width: 50px;
                            height: 50px;
                            margin-right: 15px;
                        }
                        .sponsor-content{
                            display: inline-block;
                            strong{
                                font-size: 16px;
                                color: #2B3845;
                                display: block;
                                margin-bottom: 5px;
                                font-weight: 400;
                            }
                            span{
                                display: block;
                                line-height: 1.8;
                                color: #999;
                                font-size: 13px;
                            }
                        }
                        .intro {
                            display: inline-block;
                            line-height: 20px;
                            margin-top: 10px;
                            color: #999;
                            font-size: 13px;
                        }
                    }
                    p{
                        margin-top: 0;
                        margin-bottom: 15px;
                        font-size: 18px;
                        color: #d13c3c;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
</style>

